import { useParams } from "react-router";
import { StyledBarcodePage } from "./BarcodePage.styles";
import { QRCodeGeneratorComponent } from "@syncfusion/ej2-react-barcode-generator";

export const BarcodePage: React.FC = () => {
  const { sequenceNumber } = useParams();
  return (
    <StyledBarcodePage>
      <QRCodeGeneratorComponent
        id="barcode"
        width={"400px"}
        height={"300px"}
        displayText={{ text: sequenceNumber?.toUpperCase() }}
        value={sequenceNumber?.toUpperCase()}
      ></QRCodeGeneratorComponent>
    </StyledBarcodePage>
  );
};
